module.exports = __webpack_public_path__ + "static/media/philbox-img04.bae67ce9.jpg";